/**
 * Wohin eine Benachrichtigung führt — derselbe Weg wie im Router und wie der
 * Verweis in der Mail des Benachrichtigungsdienstes (email-content.ts).
 */
const RECORD_PATHS: Record<string, (id: string) => string> = {
  finding: (id) => `/findings/${id}`,
  measure: (id) => `/measures/${id}`,
  engagement: (id) => `/engagements/${id}`,
  report: (id) => `/reports/${id}/edit`,
  audit_universe_item: (id) => `/audit-universe/${id}`,
};

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function notificationPath(
  entityType: string | null | undefined,
  entityId: string | null | undefined,
): string | null {
  if (!entityType || !entityId || !UUID.test(entityId)) return null;
  const path = RECORD_PATHS[entityType];
  return path ? path(entityId) : null;
}
